<template>
  <div class="h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Other Species Data Entry
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Select a collection code and add non-Anopheline data
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col class="tw-p-1">
          <b-form-input
            label="Collection Code"
            placeholder="Start typing collection code to filter, or double click to get list."
            v-model="keyword"
            list="cc-list"
            size="lg"
            @keypress.enter="search()"
            @click:append="search()"
          ></b-form-input>

          <datalist id="cc-list">
                <option v-for="cCode in collectionCodes" :key="cCode.id">{{ cCode.collection_code }}</option>
            </datalist>
        </b-col>
      </b-row>
    </b-container>
    <hr>

    <b-container fluid>
      <b-row>
        <b-col class="tw-p-1">
          <b-tabs v-model="tabIndex" content-class="mt-4" justified lazy>

            <b-tab title="Other Species" active>
              <template v-slot:title>
                <h4>Other Species</h4>
              </template>

              <EntoDataHOT :collectionCode="collectionCode" :collectionCodeStatus="collectionCodeStatus" templateId="other" />
            </b-tab>
            <b-tab title="Delete">
              <template v-slot:title>
                <h4>Delete</h4>
              </template>

              <EntoDataHOT :collectionCode="collectionCode" :collectionCodeStatus="collectionCodeStatus" templateId="deleted" />
            </b-tab>

          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import HandleErrors from '@/utilities/handle-errors';

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import EntoDataHOT from "@/components/unitaid/ento-data/EntoDataHOT.vue";

import { mapActions } from "vuex";
import * as _ from "lodash";

// import { HTTP } from "@/utilities/http-common";

export default {
  components: {
    EntoDataHOT
  },
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      keyword: '',
      collectionCode: '',
      collectionCodeStatus: 'draft',
      collectionCodes: [],
      selectedCollectionCode: {},
      tabIndex: 0
    }
  },
  mounted() {
    const that = this;

    that.getEntoCollectionCodes().then(response => {
      _.each(response.data, function(item) {
        // if(item.status !== 'draft') {
        //   that.collectionCodes.push(item);
        // }
        that.collectionCodes.push(item);
      });

      this.keyword = this.$route.query.collectionCode ? this.$route.query.collectionCode : '';
      this.search();
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    ...mapActions("websheet", ["getEntoCollectionCodes"]),
    search: function() {
      // this.collectionCode = this.keyword;
      const that = this;
      that.selectedCollectionCode = _.find(that.collectionCodes, ['collection_code', that.keyword]);
      that.collectionCodeStatus = that.selectedCollectionCode.status;
      that.collectionCode = that.keyword;
    }
  }
};
</script>

<style>
@import "~handsontable/dist/handsontable.full.css";

.ht {
  width: 100%;
}
.nav-tabs .nav-link {
    font-weight: 500;
    color: #999;
}
</style>
